//Comentario necesario para codificación en UTF-8, ver Inc6743
"use strict";

(function() {
	angular.module('pphhApp')
		.service("exportService", ['$http', ExportService]);

	function ExportService($http) {

		this.getListRbdExport = function() {
			return $http.get("/pphhNav/export/dhList");
		};

		this.getListAuxCcaaExport = function() {
			return $http.get("/pphhNav/export/auxCcaaList");
		};

		this.getListAxAdmonExport = function() {
			return $http.get("/pphhNav/export/auxAdmonList");
		};

		this.doExport = function(exportTypeId, rbdSelected, formatTypeId, codeCcaa, codeAdmon, ambitoModule) {
			var queryParams = "?exportType=" + exportTypeId;
			if (rbdSelected != null) {
				queryParams += "&rbdId=" + rbdSelected;
			}
			queryParams += "&formatTypeId=" + formatTypeId;

			if (codeCcaa != null) {
				queryParams += "&codeCcaa=" + codeCcaa;
			}
			if (codeAdmon != null) {
				queryParams += "&codeAdmon=" + codeAdmon;
			}
			if (ambitoModule != null) {
				queryParams += "&ambitoModule=" + ambitoModule;
			}
			return $http.get("/pphhNav/export" + queryParams);
		};

		this.checkExport = function(exportTypeId, rbdSelected, formatTypeId, codeCcaa, codeAdmon, ambitoModule) {
			var queryParams = "?exportType=" + exportTypeId;
			if (rbdSelected != null) {
				queryParams += "&rbdId=" + rbdSelected;
			}
			queryParams += "&formatTypeId=" + formatTypeId;

			if (codeCcaa != null) {
				queryParams += "&codeCcaa=" + codeCcaa;
			}
			if (codeAdmon != null) {
				queryParams += "&codeAdmon=" + codeAdmon;
			}
			if (ambitoModule != null) {
				queryParams += "&ambitoModule=" + ambitoModule;
			}
			return $http.get("/pphhNav/export/check" + queryParams);
		};

		this.callAddSubs = function(idExport) {
			return $http.get("/pphhNav/export/" + idExport + "/subs");
		};

		this.callDownloadLink = function(idExport) {
			return _contextPath + "/myDownload/access/" + idExport;
		}
	}
})();